export const QuoteRequestStatus = {
  OPEN_FOR_QUOTATIONS: "open_for_quotations",
  CLOSED_FOR_QUOTATIONS: "closed_for_quotations",
  CANCELED: "canceled",
  AUTO_CANCELED: "auto_canceled",
  APPROVAL_PENDING: "approval_pending",
  AWAITING_ACTION: "awaiting_action",
};

export const QuoteRequestStatusDisplay = {
  [QuoteRequestStatus.OPEN_FOR_QUOTATIONS]: "Open for quotations",
  [QuoteRequestStatus.CLOSED_FOR_QUOTATIONS]: "Closed for quotations",
  [QuoteRequestStatus.CANCELED]: "Canceled",
  [QuoteRequestStatus.AUTO_CANCELED]: "Auto-Canceled",
  [QuoteRequestStatus.APPROVAL_PENDING]: "Pending Approval",
  [QuoteRequestStatus.AWAITING_ACTION]: "Pending Booking",
};

export const TERMINAL_QUOTE_REQUEST_STATUSES = [
  "Booked",
  "Closed for quotations",
  "Expired",
  "Canceled",
  "Auto canceled",
  "Auto-Canceled",
  "In transit",
  "Delivered",
  "Delayed",
  "Incomplete",
  "Auto-closed",
] as const;

export const isTerminalQuoteRequestStatus = (status?: string | null): boolean => {
  if (!status) return false;

  const normalizedStatus = status.trim().toLowerCase();

  return TERMINAL_QUOTE_REQUEST_STATUSES.some((terminalStatus) => terminalStatus.toLowerCase() === normalizedStatus);
};

export const isInternalUsersOnlyCommentAudience = (requestStatus?: string | null): boolean =>
  isTerminalQuoteRequestStatus(requestStatus);
